import script from "./FakeFollowers.vue?vue&type=script&setup=true&lang=js"
export * from "./FakeFollowers.vue?vue&type=script&setup=true&lang=js"

import "./FakeFollowers.vue?vue&type=style&index=0&id=5a1137c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a1137c8"]])

export default __exports__